import React, { Component } from 'react';
import { scroll } from './navbar'
import './landing.css'
import '../index.css'
import Navbar from "./navbar";



export default class landing extends Component {
    constructor(props) {
        super(props);
        window.addEventListener('scroll', scroll, true);
    }
    componentDidMount=()=>
    {
this.myfunction();
    }
    componentDidUpdate=()=>
    {
this.myfunction();
    }
    myfunction=()=>
    {
        (function () {
            console.log('hi');
            // add click animation to social links
            var socials = document.querySelectorAll("[class*=social_lnk]");
            var i = socials.length;
            var cls = "-clicked";
            while (i--) {
              socials[i].addEventListener("click", function(e){
                var lnk = e.target;
                lnk.classList.add(cls);
          
                // Allow time for animation to complete then remove
                setTimeout(function() {
                  lnk.classList.remove(cls);
                }, 300);
              }, false);
            }
          })();
    }
    render() {
        return (
            <div class="back">
                <div class="banner">
                    <Navbar />
                    <div class="cards-list">
                        <div class="card 1 gradient-border">
                            <div class="card_image"  > <li><a class="social_lnk-youtube" href="./youtube" aria-label="Youtube"><span>Youtube</span></a></li> </div>
                            <div class="card_title title-black">
                            {/* <a href="/youtube" class="title-black">Youtube</a> */}
                            </div>
                        </div>

                        <div class="card 2 gradient-border">
                            <div class="card_image">
                            <li><a class="social_lnk-instagram" href="./instagram" aria-label="Instagram"><span>Instagram</span></a></li>
                            </div>
                            <div class="card_title title-black">
                            {/* <a href="#" class="title-black">Instagram</a> */}
                            </div>
                        </div>

                        <div class="card 3 gradient-border">
                            <div class="card_image">
                            <li><a class="social_lnk-twitter" href="./twitter" aria-label="Twitter"><span>Twitter</span></a></li>
                            </div>
                            <div class="card_title">
                            {/* <a href="#" class="title-black">Whatsapp</a> */}
                            </div>
                        </div>

                        <div class="card 4 gradient-border">
                            <div class="card_image">
                            <li><a class="social_lnk-facebook" href="./facebook" aria-label="Facebook"><span>Facebook</span></a></li>
                            </div>
                            <div class="card_title title-black">
                            {/* <a href="#" class="title-black">Playstore</a> */}
                            </div>
                        </div>
                        <div class="card 5 gradient-border">
                            <div class="card_image">
                                <li><a class="social_lnk-telegram" href="./telegram" aria-label="Telegram"><span>Telegram</span></a></li>
                            </div>
                            <div class="card_title title-black">
                            {/* <a href="#" class="title-black">Twitter</a> */}
                            </div>
                        </div>
                        <div class="card 6 gradient-border">
                            <div class="card_image">
                            <li><a class="social_lnk-whatsapp" href="./whatsapp" aria-label="Whatsapp"><span>Whatsapp</span></a></li>
                            </div>
                            <div class="card_title title-black">
                            {/* <a href="#" class="title-black">Telegram</a> */}
                            </div>
                        </div>
                        <div class="card 7 gradient-border">
                            <div class="card_image">
                            <li><a class="social_lnk-hotstar" href="./hotstar" aria-label="Hotstar"><span>Hotstar</span></a></li>
                            </div>
                            <div class="card_title title-black">
                            {/* <a href="#" class="title-black">SBI</a> */}
                            </div>
                        </div>

                    </div>

                </div>
            </div>);
    }

}